export const STORE_MIGRATIONS = '__migrations';
export const STORE_META = 'meta';
export const STORE_KEYS = 'keys';
export const STORE_CONNECTIONS = 'connections';
export const STORE_CACHE = 'cache';
export const STORE_MESSAGES = 'messages';
export const STORE_MLS_CHECKPOINTS = 'mls_checkpoints';
export const REQUIRED_STORES = [
    STORE_MIGRATIONS,
    STORE_META,
    STORE_KEYS,
    STORE_CONNECTIONS,
    STORE_MESSAGES,
    STORE_MLS_CHECKPOINTS,
];
